import styled from 'styled-components';

export const StyledMap = styled.div``;

export const PopupContainer = styled.div`
  max-width: 230px;
`;
